import React, { Component } from 'react';
import { Button } from 'react-responsive-ui'
import PropTypes from 'prop-types';

class Conversation extends Component {
    constructor(props) {
        super(props);
        this.props = props
        this.state =
            {
                channel: this.props.channel,
                messages: [],
            }
        this.messages = []
        this.getMessages = this.getMessages.bind(this)
        this.props.channel.on('messageAdded', function (message) {
            this.setState({ firstMessage: message }, () => {
                this.props.getChannels()
            })
        }.bind(this));
        this.getMessages()
    }

    componentDidMount() {
        this.getMessages()
    }

    componentWillReceiveProps(props) {
        if (this.props !== props) {
            props.channel.getMessages().then(function (messages) {
                this.setState({ messages: messages.items, firstMessage:messages.items.length > 0 ? messages.items[messages.items.length - 1] : 'New Conversation' })

            }.bind(this));
        }
        this.props = props
    }

    getMessages() {

        this.props.channel.getMessages().then(function (messages) {
            this.setState({ messages: messages.items, firstMessage: messages.items.length > 0 ? messages.items[messages.items.length - 1] : 'New Conversation'})

        }.bind(this));
    }

    render() {
        return (
            <div className={`conversation ${this.props.channel.uniqueName}`}>
                <Button className="conversation-button" action={() => { this.itemSelected(this.props.channel) }}> {this.getDisplayName(this.props.channel)}
                    <div className={`first-message-convo ${this.props.channel.uniqueName}`}>
                        <span>{this.state.firstMessage && this.state.firstMessage.body}</span>
                    </div>
                </Button>
                <button className="delete-conversation-button" onClick={() => { this.props.deleteChannel(this.props.channel) }}>Delete</button>
            </div>
        )
    }
    itemSelected(channel) {
        this.props.channelSelected(channel)
    }

    getDisplayName(channel) {
        if (channel.uniqueName.split('&')[0] == localStorage.getItem('uid')) {
            return channel.friendlyName.split('&')[1]
        } else if (channel.friendlyName && channel.friendlyName.split('&')) {
            return channel.friendlyName.split('&')[0]
        } else if (channel.friendlyName) {
            return channel.friendlyName
        } else {
            return channel.uniqueName
        }

    }
}

Conversation.propTypes = {
    history: PropTypes.object,
    channel: PropTypes.object,
    chatClient: PropTypes.object,
    updateConversationList: PropTypes.func,
    channels: PropTypes.array,
    channelSelected: PropTypes.func,
    getChannels: PropTypes.func,
    deleteChannel: PropTypes.func,
};
export default Conversation;


// WEBPACK FOOTER //
// ./src/view/conversation.js